/* ==========================================================================
   zz-variants.js — makes the variant swatches actually work.

   >>> WHAT WAS BROKEN <<<
   snippets/zz-buybox.liquid rendered the option radios and a hidden
   <input name="id"> and then NOTHING listened to them. Measured on the Imou
   Ranger 2 (2MP / 3MP / 5MP / 8MP PRO):

     - clicking a swatch changed the highlight and nothing else
     - the hidden id stayed on 52827986002232 whatever you picked
     - the price never moved off Rs 4,950
     - so EVERY order for that product was placed on one fixed variant,
       regardless of what the customer selected and paid for

   That is a wrong-goods-shipped bug, not a cosmetic one.

   >>> WHAT THIS DOES <<<
   On any change to an option radio it finds the matching variant by comparing
   the selected option values against variant.options, then updates:
     hidden input id · price · compare-at · save badge · SKU · stock line ·
     add-to-cart label and disabled state · sticky bar price · gallery image ·
     free-delivery progress · the ?variant= URL

   Options that would lead to a sold-out combination are marked, not hidden —
   hiding them makes the row jump around as you click.

   >>> THIS SCRIPT OWNS .zzb__stock OUTRIGHT — SEE TRAP 26 BELOW <<<
   It assigns textContent to that paragraph, which destroys every child node.
   Nothing may be added inside .zzb__stock from Liquid. The full explanation
   is on the apply() call site; read it before touching that block.

   No libraries. Runs after zz-product.js, which owns the gallery index.
   ========================================================================== */
(function () {
  'use strict';

  var dataEl = document.querySelector('[data-zz-variants]');
  var form = document.getElementById('zz-buy-form');
  if (!dataEl || !form) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!variants || !variants.length) return;

  var idInput = form.querySelector('[data-zz-variant-id]');
  var priceEl = document.querySelector('.zzb__price');
  var wasEl = document.querySelector('.zzb__was');
  var saveEl = document.querySelector('.zzb__save');
  var pricingEl = document.querySelector('.zzb__pricing');
  var skuEl = document.querySelector('.zzb__sku');
  var stockEl = document.querySelector('.zzb__stock');
  var atc = document.querySelector('[data-zz-atc]');
  var stickyPrice = document.querySelector('.zzsticky__price');
  var ship = document.querySelector('[data-zz-ship]');

  function selectedValues() {
    var out = [];
    form.querySelectorAll('.zzb__opt').forEach(function (opt, i) {
      var checked = opt.querySelector('input[type="radio"]:checked');
      out[i] = checked ? checked.value : null;
    });
    return out;
  }

  function findVariant(values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && v.options[j] !== values[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Mark any swatch that cannot lead to an in-stock combination. */
  function markUnavailable() {
    var values = selectedValues();
    form.querySelectorAll('.zzb__opt').forEach(function (opt, i) {
      opt.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var test = values.slice();
        test[i] = radio.value;
        var found = null;
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k];
          var ok = true;
          for (var j = 0; j < test.length; j++) {
            if (test[j] !== null && v.options[j] !== test[j]) { ok = false; break; }
          }
          if (ok && v.available) { found = v; break; }
        }
        var label = form.querySelector('label[for="' + radio.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !found);
      });
    });
  }

  function apply(v) {
    if (!v) return;

    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price;
    if (skuEl && v.sku) skuEl.textContent = v.sku;

    /* compare-at and save badge are removed from the DOM when a variant is
       not discounted, so they are rebuilt rather than just hidden — that
       keeps the markup identical to the Liquid-rendered version. */
    if (pricingEl) {
      var was = pricingEl.querySelector('.zzb__was');
      var save = pricingEl.querySelector('.zzb__save');
      if (v.save_pct > 0) {
        if (!was) {
          was = document.createElement('s');
          was.className = 'zzb__was';
          pricingEl.appendChild(was);
        }
        was.textContent = v.compare_at;
        if (!save) {
          save = document.createElement('span');
          save.className = 'zzb__save';
          pricingEl.appendChild(save);
        }
        save.textContent = 'Save ' + v.save_pct + '%';
      } else {
        if (was) was.remove();
        if (save) save.remove();
      }
    }

    /* ======================================================================
       TRAP 26 — THIS BLOCK DELETES EVERYTHING INSIDE .zzb__stock
       ----------------------------------------------------------------------
       Assigning textContent replaces ALL child nodes of the element. The dot
       is then put back by hand, because the dot is the only child this
       script knows about.

       So any markup a later edit adds inside <p class="zzb__stock"> is
       destroyed here — on first paint, before the customer ever sees it, and
       again on every swatch click.

       That has already happened once. The limited stock badge was first
       rendered inside this paragraph. It worked perfectly on single-variant
       products (where this script returns early, because there is no variant
       table) and was completely invisible on every product with swatches. No
       console error, correct Liquid, nothing to find by reading the source.
       It took inspecting the live DOM on a product with options to see it.

       THE FIX WAS STRUCTURAL, NOT HERE: the badge is now a sibling of this
       paragraph inside <div class="zzb__stockrow">, which this script never
       queries and cannot reach. Do not "simplify" that wrapper away in the
       Liquid, and do not move anything back inside this paragraph.

       If the badge ever needs to change per variant, the right fix is to
       re-render the whole ROW from here and add it to the variant table in
       zz-variants-data.liquid — not to reach into .zzb__stock.
       ====================================================================== */
    if (stockEl) {
      stockEl.classList.toggle('is-in', v.available);
      stockEl.classList.toggle('is-out', !v.available);
      var dot = stockEl.querySelector('.zzb__dot');
      stockEl.textContent = v.available ? 'In stock, ready to ship' : 'Currently out of stock';
      if (dot) stockEl.insertBefore(dot, stockEl.firstChild);
    }

    if (atc) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to cart' : 'Out of stock';
    }

    if (stickyPrice) stickyPrice.textContent = v.price;

    /* free delivery bar recalculates against the new unit price */
    if (ship) {
      ship.dataset.zzPrice = v.price_raw;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* move the gallery if this variant has its own image */
    if (v.media_index > -1) {
      var thumb = document.querySelector('[data-zz-thumb="' + v.media_index + '"]');
      if (thumb) {
        thumb.click();
      } else {
        document.querySelectorAll('[data-zz-slide]').forEach(function (s, i) {
          s.classList.toggle('is-active', i === v.media_index);
        });
      }
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    markUnavailable();
  }

  form.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="radio"][name^="option"]')) return;
    apply(findVariant(selectedValues()));
  });

  /* ---------- first paint ----------
     The Liquid marks a radio checked from option.selected_value, which on a
     plain product URL is the FIRST option value, while the price shown is the
     first AVAILABLE variant's. On the Imou Ranger 2 those disagreed: the
     8MP PRO swatch looked selected while the 2MP price was displayed.
     Deciding the truth here, once, from ?variant= if present and otherwise
     from the first available variant, removes that whole class of mismatch. */
  var initial = null;
  var param = new URL(window.location.href).searchParams.get('variant');
  if (param) {
    initial = variants.filter(function (v) { return String(v.id) === String(param); })[0] || null;
  }
  if (!initial) {
    initial = variants.filter(function (v) { return v.available; })[0] || variants[0];
  }

  if (initial) {
    form.querySelectorAll('.zzb__opt').forEach(function (opt, i) {
      var want = initial.options[i];
      opt.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = radio.value === want;
      });
    });
    apply(initial);
  }
})();